export default "__VITE_ASSET__ac85b1c0__"